import { Heading, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { useSistemasExternosQuery } from 'graphql/hooks.generated'
import { SistemaExternoQueryInput } from 'graphql/types.generated'
import { useState } from 'react'

import { SistemasExternosForm } from './SistemasExternosForm'
import { SistemasExternosTable } from './SistemasExternosTable'
export function SistemasExternosBox() {
  const [filter, setFilter] = useState<SistemaExternoQueryInput>({ pageParams: { page: 0, sort: ['dataCriacao'] } })

  const { data, loading, refetch } = useSistemasExternosQuery({
    variables: {
      input: filter,
    },
  })

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={3}>Cadastrar sistema externo</Heading>

      <Box>
        <VFlow>
          <SistemasExternosForm refetch={refetch} />
          <SistemasExternosTable data={data} loading={loading} setFilter={setFilter} refetch={refetch} />
        </VFlow>
      </Box>
    </VFlow>
  )
}
